<template>
  <div class="contenedorPrincipal">
    <page-layout
      :breadcrumbs="[
        {
          text: $t('inicio'),
          disabled: true
        }
      ]"
    >
      <v-layout style="margin:20px">
        <v-flex sm12 lg12>
          <div>
            <v-layout> <h2 class="primary--text avenir">{{ $t('m_trabajarIncidencias') }}</h2> </v-layout>
            <v-divider class="divider_subtitle"></v-divider>
            <v-container grid-list-lg fluid class="contHome" style="padding-left:0; padding-bottom:10px ">
            <v-layout row wrap>
              <v-flex
                xs12 sm12 md6 lg6
                class="tarjeta-home"
                v-for="accion in accionesPosventa"
                :key="accion.titulo"
                d-flex
              >
                <v-card 
                  class="custom-card" 
                  @click.native.stop="goTo(accion)"
                >
                  <v-img
                    :src="accion.src"
                    style="height:20vh;max-height:300px;min-height:100px"
                    :ref="'cardImage'+accion.id"
                  />
                  <v-row justify="start" no-gutters>
                    <v-col :cols="tiposSolicitud.length > 1 ? '5' : '12'">
                      <v-row align="start" no-gutters>
                        <v-col class="px-3 pt-2">
                          <span class="text-uppercase primary--text avenir homeTitle">
                            {{accionesPosventaTitle(accion)}}
                          </span>
                        </v-col>
                        <v-col cols="12" class="px-3 pb-2 pt-1">
                          <span class="grey--text avenir homeSubtitle">{{accion.desc}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="tiposSolicitud.length > 1" cols="7">
                      <v-row justify="end">
                        <v-col class="py-0">
                          <v-list class="py-0" light>
                            <v-list-item-group>
                              <v-list-item
                                v-for="(item, i) in tiposSolicitud"
                                :key="'tiposSolicitud-' + accion.desc + '-' + i"
                                @click.native.stop="goTo(accion, item.codigoTipoSolicitud)"
                              >
                                <v-list-item-content>
                                  <span class="primary--text">
                                    {{item.translates[usuario.idioma]}}
                                  </span>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-flex>
            </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
      <v-layout style="margin:20px">
        <v-flex sm12 lg12>
          <div v-if="!rolProveedor">
            <v-layout> <h2 class="primary--text avenir">{{ $t('m_masOpciones') }}</h2> </v-layout>
            <v-divider class="divider_subtitle"></v-divider>
            <v-container grid-list-lg fluid class="contHome" style="padding-left:0; padding-bottom:10px ">
            <v-layout row wrap>
              <v-flex
                xs12 sm12 md4 lg4
                class="tarjeta-home"
                v-for="accion in accionesOtras"
                :key="accion.titulo"
                d-flex
              >
                <v-card class="custom-card" @click.native.stop="goTo(accion)">
                  <v-img
                    :src="accion.src"
                    style="height:20vh;max-height:300px;min-height:100px"
                    :ref="'cardImage'+accion.id"
                  >
                  </v-img>
                    <v-layout align-center row ml-3 mr-3 mt-2 >
                      <!-- <img :src="accion.icon" style="margin-right:6px; width:20px; height:20px">-->
                      <span class="primary--text avenir homeTitle">{{accion.titulo}}</span>
                    </v-layout>
                  <v-flex ml-3 mr-3 pt-1 mt-1 mb-2>
                    <v-layout>
                      <span class="grey--text avenir homeSubtitle">{{accion.desc}}</span>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </page-layout>
    <v-footer text-md-left class="footer-custom">
       <!-- eslint-disable-next-line -->
      <span class="caption primary--text">{{ this.$t('revisionBackend') }}: {{versionApi}} {{ this.$t('revisionFrontend')}}: {{version}}</span>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
  },
  created: async function () {
    if ( this.getIdiomaISO(this.usuario.idioma) != undefined) {
      if ( this.$i18n.locale !== this.getIdiomaISO(this.usuario.idioma)) {
        this.recuperarIdioma()
        location.reload()
      }
    }
    else 
      await this.sobreescribirIdioma()
  },
  mounted () {
    if (this.esAdministrador) {
      this.$router.push({name: 'Settings'}).catch(err => { console.log(err)})
    }
    this.getEstados()
  },
  data () {
    return {
      accionesPosventa: [
        {
          id: '5',
          titulo: this.$t('m_incidencias'),
          desc: this.$t('incidenciasSubtitulo'),
          ruta: 'incidencias',
          src: require('@/assets/images/incidencias.jpg'),
          icon: require('@/assets/images/home/maestrosIcono.png')
        },
        {
          id: '1',
          titulo: this.$t('m_nuevaVisita'),
          desc: this.$t('nuevaVisitaSubtitulo'),
          ruta: 'nueva-visita',
          src: require('@/assets/images/nuevavisita.jpg'),
          icon: require('@/assets/images/home/maestrosIcono.png')
        }
      ],
      accionesOtras: [
        {
          id: '',
          titulo: this.$t('m_maestros'),
          desc: this.$t('maestrosSubtitulo'),
          ruta: 'nuevoOficio',
          src: require('@/assets/images/maestros.jpg'),
          icon: require('@/assets/images/home/maestrosIcono.png')
        }, {
          id: '',
          titulo: this.$t('m_chat'),
          desc: this.$t('chatSubtitulo'),
          ruta: 'chat',
          src: require('@/assets/images/chat.jpg'),
          icon: require('@/assets/images/home/maestrosIcono.png')
        }
      ],
      idiomas: [
        {
          cod_idioma2: 'es',
          cod_idioma: 'spa'
        },
        {
          cod_idioma2: 'en',
          cod_idioma: 'eng'
        },
        {
          cod_idioma2: 'eu',
          cod_idioma: 'eus'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      version: 'version',
      versionApi: 'versionApi',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      usuario: 'login/usuario',
      rolProveedor: 'login/rolProveedor'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      guardarIdiomaUsuario: 'configuracion/guardarIdiomaUsuario',
      updateActor: 'login/updateActor',
      getEstados: 'incidencias/getStatusTypes',
    }),
    goTo (accion, codigoTipoSolicitudes = 0) {
      let routeObj = {name: accion.ruta}
      if (codigoTipoSolicitudes !== 0) {
        this.$store.commit('incidencias/setCodigoTipoSolicitudes', codigoTipoSolicitudes)
        routeObj.params = { codigoTipo: codigoTipoSolicitudes }
      } else if (this.tiposSolicitud.length === 1) {
        this.$store.commit('incidencias/setCodigoTipoSolicitudes', this.tiposSolicitud[0].codigoTipoSolicitud)
        routeObj.params = { codigoTipo: this.tiposSolicitud[0].codigoTipoSolicitud }
      }
      this.$store.commit('incidencias/setCodigoTipoSolicitudes', '')
      this.$router.push(routeObj).catch(err => { console.log(err)})
    },
    getImgUrl (img) {
      return require('@' + img)
    },
    accionesPosventaTitle (accion) {
      return accion.titulo
    },
    async sobreescribirIdioma() {
      // const nuevoIdiomaUsuario = this.$i18n.locale
      const obj = {
          actorName: this.usuario.nombre,
          actorSurname: this.usuario.apellidos,
          actorPhoneNumber: this.usuario.telefono,
          actorLanguage: this.getCodIdioma(this.$i18n.locale),
          actorDocumentType: this.usuario.tipoDocumento,
          actorNumDocument: this.usuario.documento
        }
      await this.updateActor(obj)
      await this.guardarIdiomaUsuario(this.getCodIdioma(this.$i18n.locale))
      this.dialogCambiarIdioma = false
      this.$store.state.mostrarPopupCambioIdioma = false
    },
    getIdiomaISO(cod_idioma) {
      return this.idiomas.map(idioma => (idioma.cod_idioma === cod_idioma) ? idioma.cod_idioma2 : '').filter(value => value !== "")[0]
    },
    getCodIdioma(cod_idioma_iso) {
      return this.idiomas.map(idioma => (idioma.cod_idioma2 === cod_idioma_iso) ? idioma.cod_idioma : '').filter(value => value !== "")[0]
    },
    cancelIdioma () {
      this.dialogCambiarIdioma = false
      this.$store.state.login.mostrarPopupCambioIdioma = false
    },
    recuperarIdioma() {
      this.$i18n.locale = this.getIdiomaISO(this.usuario.idioma)
      localStorage.setItem('i18n', this.getIdiomaISO(this.usuario.idioma))
      this.dialogCambiarIdioma = false
      this.$store.state.login.mostrarPopupCambioIdioma = false
    }
  }
}
</script>

<style lang="sass">

  .contHome
    margin-bottom: 20px

  .homeTitle
    font-size: 1.3em

  .homeSubtitle
    font-size: 1.1em

  .contHome
    padding-left:0

  body.hideScrollbar::-webkit-scrollbar
    opacity: 0

  .footer-pos
    position: absolute
    top: 100vh
    width: 100%

  @media (min-width: 1024px)
    .container.grid-list-lg .layout .flex.tarjeta-home.sm3
      flex-basis: 22%
      max-width: 22%
      margin: 8px
      padding: 0px
      min-width: 260px

  .footer-custom 
    height: 20px
    display: flex
    justify-content: flex-end
    position:absolute
    bottom:0

</style>
